export default __webpack_public_path__ + "static/media/hero-bcg.a8f7a7e7.jpg";